import React from "react";
import GaugeChart from "react-advanced-gauge-chart";

const chartStyle = {
  width:300,

};
const GuageMeter = () => {
  return (
    <div>
      <GaugeChart
        id="gauge-chart1"
        nrOfLevels={420}
        arcsLength={[0.3, 0.8, 0.3]}
        colors={["#FF3A29", "#FFE352", "#34B53A"]}
        arcPadding={0}
        style={chartStyle}
        cornerRadius={0}
        arcWidth={0.3}
        hideText={true}
        needleColor="#466089"
        needleBaseColor="#FFE352"
      />
    </div>
  );
};

export default GuageMeter;
